// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3b9tu","label":"styles_label__1SbeS"};